import React from "react";
import { CheckCircleIcon, ClockIcon, XCircleIcon } from "@heroicons/react/24/outline";
import { getStatusTextClass } from "../../shared/utils/statusText";

// Same numbers as the API Status enum on migrations and their tasks
export const MigrationStatus = {
  Pending: 0,
  Initialized: 1,
  InProgress: 2,
  Error: 3,
  Completed: 4,
} as const;

export const isMigrationFinished = (status: number) =>
  status === MigrationStatus.Completed || status === MigrationStatus.Error;

// A run that died without updating its row stays unfinished for good, so only recent ones are worth polling
const POLL_WINDOW_MS = 6 * 60 * 60 * 1000;

export const isMigrationRunning = (status: number, createdAt?: string) =>
  !isMigrationFinished(status) && !!createdAt && Date.now() - new Date(createdAt).getTime() < POLL_WINDOW_MS;

export const MigrationStatusIcon = ({ status }: { status: number }) => {
  if (status === MigrationStatus.Completed) {
    return <CheckCircleIcon className={`h-5 w-5 mt-0.5 shrink-0 ${getStatusTextClass("succeeded")}`} />;
  }

  if (status === MigrationStatus.Error) {
    return <XCircleIcon className={`h-5 w-5 mt-0.5 shrink-0 ${getStatusTextClass("failed")}`} />;
  }

  if (status === MigrationStatus.InProgress) {
    return (
      <svg
        className={`animate-spin h-5 w-5 mt-0.5 shrink-0 ${getStatusTextClass("running")}`}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
    );
  }

  return <ClockIcon className="h-5 w-5 mt-0.5 shrink-0 text-slate-500" />;
};
